<template>
  <div class="appointment-cancel-detail" :class = "{'clear-header':isWechatBrowser}">
    <my-header v-if="!isWechatBrowser" class="top-title" title="预约取消审核" :showBack="true"></my-header>
    <div class="cancel-check-result">
      <div>审核不通过</div>
      <div class="check-time">{{cancelAppointmentCheck.checkTime | shortTime}}</div>
    </div>
    <div class="cancel-check-info">
      <div>取消原因：{{cancelAppointmentCheck.reason}}</div>
      <div class="cancel-apply-btn" @click="applyCancelCheck()">申请取消</div>
    </div>
    <div v-if="cancelAppointmentModal" class="pay-box"></div>
    <div v-if="cancelAppointmentCheckModal" class="cancel-toast refuse-modal">
      <div class="cancel-toast-title">申请取消原因</div>
      <div class="cancel-appointment-reason-part">
        <textarea class="cancel-appointment-reason-text" v-model="cancelReason" rows="6" placeholder="请输入取消预约原因"></textarea>
      </div>
      <div class="confirm-footer" >
        <div class="agree-btn" @click = "createCancelAppointmentCheck">确定</div>
        <div class="cancel-btn" @click = "closeApplyCancelAppointment">取消</div>
      </div>
    </div>
    <div v-if="cancelAppointmentCheckModal" class="pay-box"></div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import session from '../../utils/Session'
  import cancelAppointmentCheckService from '../../service/customer/CancelAppointmentCheckService'

  export default {
    name: 'AppointmentCancelCheckDetail',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        appointmentId:'',
        cancelAppointmentCheckId:'',
        cancelAppointmentCheck:{},
        isWechatBrowser:this.$verfyBrowserType(),
        cancelAppointmentModal:false,
        cancelAppointmentCheckModal:false,
        cancelReason:'',
      }
    },
    created (){
      this.appointmentId = this.$route.query.appointmentId;
      this.cancelAppointmentCheckId = this.$route.query.cancelAppointmentCheckId;
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getAppointmentCancelCheckDetail();
    },
    methods: {
      async getAppointmentCancelCheckDetail(){
        let {code,msg,data} = await cancelAppointmentCheckService.getCancelAppointmentDetail(this.cancelAppointmentCheckId);
        if(code == '0'){
          this.cancelAppointmentCheck = data;
        }else {
          Toast('获取取消预约详情失败');
        }
      },
      applyCancelCheck(){
        this.cancelAppointmentCheckModal = true;
      },
      async createCancelAppointmentCheck(){
        let cancelAppointmentCheck = {appointmentId:this.appointmentId,customerId:session.getAccountToken().id,reason:this.cancelReason};
        let {code,msg,data} = await cancelAppointmentCheckService.createCancelAppointment(cancelAppointmentCheck);
        if(code == '0'){
          this.cancelAppointmentCheckModal = false;
          this.cancelReason = '';
          Toast('您的申请已提交!');
          this.$router.go(-1);
        }else {
          Toast('您的申请提交失败!');
        }
      },
      closeApplyCancelAppointment(){
        this.cancelAppointmentCheckModal = false;
      },
    }
  }
</script>
<style lang="scss">
  .appointment-cancel-detail{
    font-size: 0.32rem;
    color: #878e99;
    .cancel-check-result{
      text-align: left;
      background-color: #f3f8fc;
      padding: 0.52rem 0 0.64rem 0.3rem;
      .check-time{
        font-size: 0.22rem;
      }
    }
    .cancel-check-info{
      position: relative;
      font-size: 0.28rem;
      color: #1b1e29;
      text-align: left;
      padding: 0.32rem 0 0 0.32rem;
    }

    .cancel-apply-btn{
      position: absolute;
      width: 1.69rem;
      height: 0.61rem;
      background-color: #1D8AE7;
      border-radius: 0.4rem;
      font-size: 0.28rem;
      color: white;
      text-align: center;
      line-height: 0.61rem;
      right: 0.3rem;
    }
    .canceled-btn{
      width: 1.69rem;
      height: 0.61rem;
      background-color: #d5dee2;
      border-radius: 0.4rem;
      font-size: 0.28rem;
      color: white;
      text-align: center;
      margin-right: 0.3rem;
      margin-left: 0.3rem;
      line-height: 0.61rem;
      margin-bottom: 0.36rem;
    }
    .refuse-modal{
      width: 6rem;
      text-align: left;
      background-color: white;
      z-index: 1002;

      .refuse-modal-title{
        border-top-left-radius: 0.1rem;
        border-top-right-radius: 0.1rem;
        background-color: #1d8ae7;
        color: white;
        font-weight: 600;
        padding-left: 0.4rem;font-size: 0.32rem;line-height: 0.9rem
      }
      .refuse-modal-text{
        padding-left: 0.4rem;
        padding-top: 0.4rem;
        padding-bottom: 0.58rem;
        font-size: 0.28rem;
        color: #878e99;
      }
      .cancel-appointment-reason-part{
        width: 4.72rem;
        padding-bottom: 0.4rem;
        margin: 0 auto;
        .cancel-appointment-reason-text{
          width: 100%;
          padding: 0.2rem 0 0 0.2rem;
          background: #f3f8fc;
          font-size: 0.28rem;
          resize:none
        }
      }
    }
    .cancel-toast{
      background-color: white;
      width: 6rem;
      position: fixed;
      color: white;
      border-radius: 0.1rem;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    .cancel-toast-title{
      font-size: 0.32rem;
      color: #1b1e29;
      text-align: center;
      padding: 0.3rem 0 0.35rem 0;
    }
    .pay-box{
      overflow: hidden;
      position:fixed;
      top:0;
      bottom:0;
      left:0;
      right:0;
      background-color: rgba(0, 0, 0,0.5);
      z-index: 1001
    }
    .confirm-footer{
      width: 3.88rem;
      margin: 0 auto;
      font-size: 0.28rem;
      padding-bottom: 0.4rem;
      display: flex;
      justify-content: space-between;
      .agree-btn{
        background-color: #1d8ae7;
        border-radius: 0.3rem;
        text-align: center;
        width: 1.7rem;
        height: 0.62rem;
        line-height: 0.7rem;
        color: white;
      }
      .cancel-btn{
        background-color: white;
        border-radius: 0.3rem;
        border: solid 1px #d5dee2;
        width: 1.7rem;
        height: 0.62rem;
        line-height: 0.7rem;
        text-align: center;
        color: #1b1e29
      }
    }
  }
</style>
